import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';

@UntilDestroy()
@Component({
    selector: 'app-new-agreement-periods-renewals',
    templateUrl: './new-agreement-periods-renewals.component.html',
    styleUrl: './new-agreement-periods-renewals.component.scss'
})
export class NewAgreementPeriodsAndRenewalsComponent {
    @Input() public agreementForm: FormGroup<AgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;
    @Output() public fileDialogStateChange = new EventEmitter<boolean>();

    public get detailsForm() {
        return this.agreementForm.controls.details;
    }

    public get periodForm() {
        return this.agreementForm.controls.period;
    }

    public get reminderForm() {
        return this.agreementForm.controls.reminder;
    }

    public get fileForm() {
        return this.agreementForm.controls.fileUpload;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public showReminder(): boolean {
        return this.periodForm.controls.validTo.value !== null;
    }

    public onFileDialogStateChange(isOpen: boolean) {
        this.fileDialogStateChange.emit(isOpen);
    }
}
